import { makeDataErrorMessages } from '@atlassian/amkt-common';
import { parse as parseAri } from '@atlassian/cs-ari';
import { log } from '@atlassian/mpac-utils';
import { Option } from 'funfix-core';
import { List } from 'immutable';
import { makeContextFromSPIContext } from '../records/Context';
import getSPI from '../services/SPI';
import { getRequestId } from '../utils/request-utils';
export const FETCH_CONTEXTS = 'CONTEXTS_FETCH';
export const RECEIVE_CONTEXTS = 'CONTEXTS_RECEIVE';
export const RECEIVE_DATA_ERROR = 'CONTEXTS_RECEIVE_DATA_ERROR';
export const CHANGE_CONTEXT = 'CONTEXTS_CHANGE_CONTEXT';
function fetchContexts(_ref) {
  let {
    contextSearchId
  } = _ref;
  return {
    type: FETCH_CONTEXTS,
    contextSearchId
  };
}
function receiveContexts(_ref2) {
  let {
    contexts,
    contextSearchId
  } = _ref2;
  return {
    type: RECEIVE_CONTEXTS,
    contextSearchId,
    contexts
  };
}
export function changeContext(selectedContext) {
  return {
    type: CHANGE_CONTEXT,
    selectedContext
  };
}
export function receiveDataError(dataErrorMessages) {
  return {
    type: RECEIVE_DATA_ERROR,
    dataErrorMessages
  };
}
export function doRetrieveContexts(filter) {
  return dispatch => {
    const contextSearchId = getRequestId();
    dispatch(fetchContexts({
      contextSearchId
    }));
    getSPI().getContexts({
      query: {
        search: filter,
        limit: 20
      }
    }).then(paginatedContexts => {
      const contexts = List(paginatedContexts.values).map(makeContextFromSPIContext);
      dispatch(receiveContexts({
        contexts,
        contextSearchId
      }));
    }).catch(error => {
      dispatch(receiveDataError(makeDataErrorMessages([error])));
      console.error('getContexts was rejected by the SPI and returned the following error:', error);
    });
  };
}
export function doRetrieveDefaultContext() {
  return dispatch => {
    getSPI().getMostRecentContext().then(Option.of).then(oc => {
      oc.filter(spiContext => {
        const parsedContextId = parseAri(spiContext.id);
        // We only accommodate for non-global contexts for now. The global context has no resourceId
        return !!parsedContextId.resourceId;
      }).map(spiContext => {
        dispatch(changeContext(makeContextFromSPIContext(spiContext)));
      });
    }).catch(error => {
      log.error('actions/Contexts', "'getMostRecentContext was rejected by the SPI and returned the following error", {
        error
      });
    });
  };
}